// extracted by mini-css-extract-plugin
module.exports = {"map":"Snackbar_map__xXMg1","wrapper":"Snackbar_wrapper__1VGeF","frame":"Snackbar_frame__s2wrc","text":"Snackbar_text__13iT-","action":"Snackbar_action__D4X4O"};